<template>
    <h1 class="PageTitle">
        <slot />
    </h1>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
.PageTitle {
    font-weight: 900;
    font-size: 42px;
    line-height: 50px;
    margin: 8px 0;
    color: #FFFFFF;
    letter-spacing: 1px;

    @media only screen and (max-width: $f2m-desktop-breakpoint) {
        font-size: 30px;
        font-weight: 800;
        line-height: 36px;
    }
}

</style>
